import HTTP from "@/plugins/http";
import utils from "@/resources/utils";
import validationStatusCode from "@/resources/validation_status_code";

const getPetsWithoutPag = async token =>
  validationStatusCode(
    await HTTP.get("/pets/without_pagination/", {
      headers: utils.headerAuth(token)
    })
  );

const getPets = async (token, page, search) => {
  let endpoint = `/pets/?page=${page}`;

  if (search) endpoint += `&search=${encodeURIComponent(search)}`;

  return validationStatusCode(
    await HTTP.get(endpoint, { headers: utils.headerAuth(token) })
  );
};

const getPet = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/pets/${id}`, { headers: utils.headerAuth(token) })
  );

const createPet = async (pet, token) => {
  return validationStatusCode(
    await HTTP.post("/pets/", pet, { headers: utils.headerAuthFile(token) })
  );
};

const updatePet = async (id, pet, token) => {
  return validationStatusCode(
    await HTTP.patch(`/pets/${id}/`, pet, {
      headers: utils.headerAuthFile(token)
    })
  );
};

const deletePet = async (id, token) =>
  validationStatusCode(
    await HTTP.delete(`/pets/${id}/`, { headers: utils.headerAuth(token) })
  );

const searchPet = async code =>
  validationStatusCode(
    await HTTP.post(
      "/pets/search_pet_by_code/",
      { code },
      {
        headers: utils.header
      }
    )
  );

const contactOwner = async (pet, location, person) =>
  validationStatusCode(
    await HTTP.post(
      `/pets/${pet.id}/contact_pet_owner/`,
      { pet, location, person },
      { headers: utils.header }
    )
  );

const generateCarnetPDF = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/pets/${id}/generate_pet_pdf/`, {
      responseType: "blob",
      headers: utils.headerAuth(token)
    })
  );

const generateHistoryPDF = async (id, token) =>
  validationStatusCode(
    await HTTP.get(`/vaccination_cards/generate_vaccine_card_pdf?pet=${id}`, {
      responseType: "blob",
      headers: utils.headerAuth(token)
    })
  );

export default {
  getPetsWithoutPag,
  getPets,
  getPet,
  createPet,
  updatePet,
  deletePet,
  searchPet,
  generateCarnetPDF,
  generateHistoryPDF,
  contactOwner
};
